import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import adderessListApi from '../../../middleware/api/Invoicing/AdderessList/adderessListApi'
import {
  AddAdderessListProps,
  AdderessListState,
  CountryLookUpDTO,
  GetAddressDetailsList,
} from '../../../types/Invoicing/AdderessList/adderesslist'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import { RootState } from '../../../stateStore'

const getAdderessList = createAsyncThunk(
  'adderessList/getAdderessList',
  async (_, thunkApi) => {
    try {
      return await adderessListApi.getAdderessList()
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const deleteAddressDetails = createAsyncThunk(
  'deleteAddress/deleteAddressDetails',
  async (addressId: number, thunkApi) => {
    try {
      return await adderessListApi.deleteAdderessList(addressId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const addAddress = createAsyncThunk(
  'addAddress/addAddress',
  async (addAdderessList: AddAdderessListProps, thunkApi) => {
    try {
      return await adderessListApi.addAddress(addAdderessList)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const updateAddres = createAsyncThunk(
  'updateAddress/updateAddres',
  async (updateAdderessList: AddAdderessListProps, thunkApi) => {
    try {
      return await adderessListApi.updateAddress(updateAdderessList)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const getCountryLookup = createAsyncThunk(
  'countryLookup/getCountryLookup',
  async (_, thunkApi) => {
    try {
      return await adderessListApi.getCountryLookup()
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

export const initialAdderessListate: AdderessListState = {
  getAddressDetailsList: [],
  isLoading: ApiLoadingState.idle,
  countryLookUpDTO: [],
  addAdderessList: [],
}

const adderessListSlice = createSlice({
  name: 'adderessList',
  initialState: initialAdderessListate,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(isAnyOf(getAdderessList.pending), (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addMatcher(isAnyOf(getAdderessList.fulfilled), (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.getAddressDetailsList = action.payload
      })
      .addMatcher(isAnyOf(getCountryLookup.fulfilled), (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.countryLookUpDTO = action.payload
      })
  },
})

const adderessListThunk = {
  getAdderessList,
  deleteAddressDetails,
  addAddress,
  updateAddres,
  getCountryLookup,
}

const isLoading = (state: RootState): LoadingState =>
  state.adderessList.isLoading
const getAddressDetailsList = (state: RootState): GetAddressDetailsList[] =>
  state.adderessList.getAddressDetailsList

const countryLookUpDTOList = (state: RootState): CountryLookUpDTO[] =>
  state.adderessList.countryLookUpDTO

const addAddressDTOList = (state: RootState): AddAdderessListProps[] =>
  state.adderessList.addAdderessList

const adderessListSelectors = {
  isLoading,
  getAddressDetailsList,
  countryLookUpDTOList,
  addAddressDTOList,
}

export const adderessListService = {
  ...adderessListThunk,
  actions: adderessListSlice.actions,
  selectors: adderessListSelectors,
}

export default adderessListSlice.reducer
